<auto-main-navigation [accountId]="accountId?.toString()"></auto-main-navigation>

<div class="offer-set-list-page">
  <p-toast></p-toast>

  <div class="page-header">
    <div class="title-wrap">
      <h1>Offer Set List</h1>
    </div>
<!--    <div class="header-actions">-->
<!--      <button pButton type="button" class="p-button-secondary" label="View Inventory" (click)="viewInventory()"></button>-->
<!--      <button pButton type="button" class="p-button-warning build-new-offer-btn" label="+ Build New Offer Set" (click)="buildNewOfferSet()"></button>-->
<!--    </div>-->
  </div>

  <div class="toolbar">
    <div class="toolbar-section">
      <div class="toolbar-row">
        <div class="view-tabs">
          @for (tab of presetTabs; track tab.preset) {
            <button pButton type="button"
                    [class]="activePreset === tab.preset ? 'tab active' : 'tab'"
                    [label]="tab.label"
                    (click)="selectPreset(tab)">
            </button>
          }
        </div>
        <div class="search-wrap">
          <span class="p-input-icon-left search-input-wrap">
            <i class="pi pi-search"></i>
            <input pInputText
                   type="text"
                   placeholder="Search by title, stock #, VIN, year / make / model"
                   [value]="searchTerm"
                   (input)="onSearchChange($any($event.target).value)" />
          </span>
        </div>
      </div>
    </div>

    <div class="toolbar-section">
      <div class="toolbar-row">
        <div class="filters">
          <p-select [options]="statusOptions"
                    [(ngModel)]="selectedStatus"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Status"
                    [appendTo]="'body'"
                    (onChange)="onFilterChange()">
            <ng-template pTemplate="selectedItem" let-value>
              <span class="filter-prefix">Status:</span>
              <span class="filter-value">{{ value?.label }}</span>
            </ng-template>
          </p-select>
          <p-select [options]="conditionOptions"
                    [(ngModel)]="selectedCondition"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Condition"
                    [appendTo]="'body'"
                    (onChange)="onFilterChange()">
            <ng-template pTemplate="selectedItem" let-value>
              <span class="filter-prefix">Condition:</span>
              <span class="filter-value">{{ value?.label }}</span>
            </ng-template>
          </p-select>
          <p-select [options]="visibilityOptions"
                    [(ngModel)]="selectedVisibility"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Visibility"
                    [appendTo]="'body'"
                    (onChange)="onFilterChange()">
            <ng-template pTemplate="selectedItem" let-value>
              <span class="filter-prefix">Visibility:</span>
              <span class="filter-value">{{ value?.label }}</span>
            </ng-template>
          </p-select>
        </div>
      </div>
    </div>
  </div>
  <div class="select-all-across" *ngIf="items.length > 0">
    <ng-container *ngIf="!selectAllAcrossPages; else allAcrossActiveTop">
      <div class="hint" *ngIf="selectedItems.length === items.length && pagination.totalItems > items.length">
        All {{ items.length }} items on this page are selected.
        <a href="#" (click)="$event.preventDefault(); selectAllAcross()">Select all {{ pagination.totalItems }} results</a>
      </div>
    </ng-container>
    <ng-template #allAcrossActiveTop>
      <div class="hint">
        All {{ pagination.totalItems }} results are selected across all pages.
        <a href="#" (click)="$event.preventDefault(); clearSelection()">Clear selection</a>
      </div>
    </ng-template>
  </div>

  <div class="table-card">
    <div class="table-header">
      <div class="table-title">Offer Sets</div>
      <div class="table-header-right">
      <span class="summary-text">
        Showing
        {{ pagination.totalItems === 0 ? 0 : ((pagination.page - 1) * pagination.pageSize) + 1 }}
        –
        {{ pagination.totalItems === 0 ? 0 : (((pagination.page * pagination.pageSize) > pagination.totalItems) ? pagination.totalItems : (pagination.page * pagination.pageSize)) }}
        of {{ pagination.totalItems }} results.
      </span>
        <div class="bulk-actions">
          <p-select [options]="bulkActionOptions"
                    [(ngModel)]="selectedBulkAction"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Bulk Action: Select"
                    [appendTo]="'body'">
          </p-select>
          <button pButton type="button"
                  class="p-button-secondary bulk-apply-btn"
                  label="Apply"
                  [disabled]="!selectedBulkAction || (!selectAllAcrossPages && selectedItems.length === 0)"
                  (click)="applyBulkAction()">
          </button>
        </div>
      </div>
    </div>


      @if (isLoading) {
        <div class="loading-container">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }

    @if (!isLoading && items.length === 0) {
      <div class="empty-state">
        <p>No Offer Sets found matching the current filters.</p>
      </div>
    }

    @if (!isLoading && items.length > 0) {
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th class="checkbox-col">
                <p-checkbox binary="true" [ngModel]="allSelected" (onChange)="toggleSelectAll($event)"></p-checkbox>
              </th>
              <th class="status-col">Status</th>
              <th class="vehicle-col">Vehicle</th>
              <th class="condition-col">Condition</th>
              <th class="visibility-col">Visibility</th>
              <th class="pricing-col">Pricing</th>
              <th class="offers-col">Offers</th>
              <th class="tags-col">Tags</th>
              <th class="dates-col">Dates</th>
              <th class="actions-col">Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.id) {
              <tr>
                <td class="checkbox-col">
                  <p-checkbox binary="true" [ngModel]="isItemSelected(item)" (onChange)="toggleItemSelection(item)"></p-checkbox>
                </td>
                <td class="status-col">
                  <div class="status-toggle">
                    <p-toggleSwitch [ngModel]="item.data.active" (onChange)="toggleStatus(item)"></p-toggleSwitch>
                    <span>{{ item.data.active ? 'Active' : 'Inactive' }}</span>
                  </div>
                </td>
                <td class="vehicle-col">
                  <div class="vehicle-cell">
                    <div class="vehicle-image">
                      @if (item.data.vehicleImage) {
                        <img [src]="item.data.vehicleImage" [alt]="item.data.displayTitle" />
                      }
                    </div>
                    <div class="vehicle-info">
                      <div class="vehicle-title">{{ item.data.displayTitle }}</div>
                      <div class="meta-line">Stock #: {{ item.data.stockNumber || 'N/A' }}</div>
                      <div class="meta-line">VIN: {{ item.data.vinNumber || 'N/A' }}</div>
                      @if (item.data.fullDisclosure) {
                        <a href="#" class="meta-line disclosure-link" (click)="openDisclosure(item); $event.preventDefault()">View Disclosure</a>
                      }
                      <div class="meta-line">Sale Ends: {{ item.data.saleEndDate ? (item.data.saleEndDate | date:'MM/dd/yy') : 'N/A' }}</div>
                    </div>
                  </div>
                </td>
                <td class="condition-col">
                  <span class="pill">{{ item.data.newUsed }}</span>
                </td>
                <td class="visibility-col">
                  <span class="pill">{{ item.data.visibilityScope }}</span>
                </td>
                <td class="pricing-col">
                  <div class="data-block">
                    <div class="data-label">MSRP</div>
                  <div class="data-value">{{ item.data.msrp ? ('$' + (item.data.msrp | number:'1.0-0')) : '—' }}</div>
                    <div class="data-label">Buy Price</div>
                  <div class="data-value">{{ item.data.buyPrice ? ('$' + (item.data.buyPrice | number:'1.0-0')) : '—' }}</div>
                </div>
              </td>
              <td class="offers-col">
                <div class="data-block">
                  <div class="data-label">Lease</div>
                  <div class="data-value">{{ (item.data.leasePrice > 0) ? ('$' + (item.data.leasePrice | number:'1.0-0') + '/mo for ' + item.data.leaseTerm + ' mos.'  ) : '—' }}</div>
                  <div class="data-label">APR</div>
                  <div class="data-value">{{ (item.data.availableApr && item.data.availableAprText) ? (item.data.availableApr + '% for ' + item.data.availableAprText + ' mos.') : '—' }}
                  </div>
                  <div class="data-label">Finance</div>
                  <div class="data-value">{{ (item.data.financePayment > 0 && item.data.financeTerm > 0) ? (item.data.financeTerm ? ('$' + (item.data.financePayment | number:'1.0-0') + '/mo for ' + item.data.financeTerm + ' mos.') : ('$' + (item.data.financePayment | number:'1.0-0'))) : '—' }}</div>
                  <div class="data-label">Alternate Lease</div>
                  <div class="data-value">{{ (item.data.zeroDownLeasePrice > 0) ? ('$' + (item.data.zeroDownLeasePrice | number:'1.0-0') + '/mo for ' + item.data.zeroDownLeaseTerm + ' mos.'  ) : '—' }}</div>
                </div>
              </td>
                <td class="tags-col">
                  <div class="tag-group">
                    @if (item.data.featuredSpecial) { <span class="tag featured">Featured</span> }
                    @if (item.data.isPrivate) { <span class="tag private">Private</span> }
                    @if (item.data.isCreativeOffer) { <span class="tag creative">Creative</span> }
                    @if (item.data.customSpecial) { <span class="tag custom">Custom</span> }
                    @if (item.isShared) { <span class="tag shared">Shared</span> }
                  </div>
                </td>
                <td class="dates-col">
                  <div class="meta-line"><strong>Created:</strong> {{ item.data.created ? (item.data.created | date:'MM/dd/yyyy') : '—' }}</div>
                  <div class="meta-line"><strong>Updated:</strong> {{ item.data.modified ? (item.data.modified | date:'MM/dd/yyyy') : '—' }}</div>
                </td>
                <td class="actions-col">
                  <div class="row-actions">
                    <button pButton type="button" class="p-button-text p-button-info action-btn" icon="pi pi-pencil" (click)="editOfferSet(item)"></button>
                    <button pButton type="button" class="p-button-text p-button-danger action-btn" icon="pi pi-trash" (click)="openDeleteConfirmation(item)"></button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="select-all-across" *ngIf="items.length > 0">
        <ng-container *ngIf="!selectAllAcrossPages; else allAcrossActive">
          <div class="hint" *ngIf="selectedItems.length === items.length && pagination.totalItems > items.length">
            All {{ items.length }} items on this page are selected.
            <a href="#" (click)="$event.preventDefault(); selectAllAcross()">Select all {{ pagination.totalItems }} results</a>
          </div>
        </ng-container>
        <ng-template #allAcrossActive>
          <div class="hint">
            All {{ pagination.totalItems }} results are selected across all pages.
            <a href="#" (click)="$event.preventDefault(); clearSelection()">Clear selection</a>
          </div>
        </ng-template>
      </div>

      <div class="pagination-bar">
        <p-paginator [rows]="pagination.pageSize"
                     [totalRecords]="pagination.totalItems"
                     [first]="(pagination.page - 1) * pagination.pageSize"
                     [rowsPerPageOptions]="[25, 50, 100]"
                     (onPageChange)="onPageChange($event)">
        </p-paginator>
      </div>
    }
  </div>

  <p-confirmDialog key="deleteOfferSet"></p-confirmDialog>
  <p-confirmDialog key="bulkDeleteOfferSets"></p-confirmDialog>

  <p-dialog [(visible)]="disclosureDialogVisible"
            [modal]="true"
            [style]="{width: '600px', maxWidth: '95vw'}"
            [draggable]="false"
            [resizable]="false"
            [dismissableMask]="true"
            (onHide)="closeDisclosure()"
            [header]="disclosureTitle || 'Disclosure'">
    <div class="disclosure-content" [innerHTML]="disclosureHtml"></div>
    <ng-template pTemplate="footer">
      <button pButton type="button" label="Close" (click)="closeDisclosure()"></button>
    </ng-template>
  </p-dialog>
</div>
